module.exports = __webpack_public_path__ + "img/icon_arch.aefad9b7.png";